'use strict';

var productTile = require('../product-tile'),
    progress = require('../progress'),
    util = require('../util'),
    contentAssetHelper = require('../contentassethelper'),
    rating = require('../rating'),
    scrollDirection;

function lazyLoadTileImages(){
    // 1. get site preferences & set defaults. hardcode fallback settings in case configs are empty or invalid
    var settingsJSON = { "default": { "threshold":0, "tiles_per_load":1} };
    if(!!window.SitePreferences.PLP_LAZY_LOAD_SETTINGS) {
        try {
            settingsJSON = JSON.parse(window.SitePreferences.PLP_LAZY_LOAD_SETTINGS);
        } catch(e) {
            console.warn("PLP Lazy Load configuration error: Invalid JSON in Site Preference 'tileImageLazyLoadSettings'.", e);
        }
    }
    var keys = Object.keys(settingsJSON), length = keys.length, threshold = settingsJSON.default.threshold, numTiles = settingsJSON.default.tiles_per_load;
    keys.sort();

    // 2. get settings from json object based on viewport width
    for(var i=0;i<length;i++) {
        if(keys[i] == 'default') continue;
        if(window.matchMedia('(max-width: ' + keys[i] + 'px)').matches){
            threshold = settingsJSON[keys[i]]['threshold'];
            numTiles = settingsJSON[keys[i]]['tiles_per_load'];
            break;
        }
    }

    // 3. initialize unveil
    $('.search-result-items .product-tile .product-name-image-container img').unveil(threshold, function(){
        // this callback his called when an image is 'unveiled', i.e. it crosses the threshold

        // unveil doesn't catch the rollover images b/c they are hidden, so we have to do those manually
        var $rolloverImg = $(this).siblings('.p-image-rollover');
        $rolloverImg.attr('src', $rolloverImg.data('src'));

        // when a product tile image is loaded, load the next <numTiles> images and turn off unveil on them to prevent recursion
        var index = $('.product-tile .product-name-image-container img').index($(this));
        var C = scrollDirection == 'up' ? -1 : 1;
        var $chunk = $('.product-tile .product-name-image-container img').slice(index, index + C*numTiles);
        $chunk.each(function(){
            var $curObj = $(this);
            $rolloverImg = $(this).siblings('.p-image-rollover');
            $rolloverImg.attr('src', $rolloverImg.data('src'));
        });
      });

    // function for swatch
    $('.search-result-items .product-tile .swatch-list img').unveil(threshold, function(){
       // when a product tile image is loaded, load the next <numTiles> images and turn off unveil on them to prevent recursion
        var index = $('.product-tile .swatch-list img').index($(this));
        var C = scrollDirection == 'up' ? -1 : 1;
            
        var $bChunk = $('.product-tile .grid-bottom-section  .swatch-list a ').slice(index, index + C*numTiles);
        $bChunk.each(function(){
        	let $curObj = $(this);
            let curSrc = $curObj.css("backgroundImage") || $curObj[0].style.backgroundImage;
            let finalBack = $curObj.find('img.swatch-image').data('src');
            if(curSrc && curSrc.indexOf('NO-SWATCH-TAB.svg') == -1 ) {
            	$curObj.css('backgroundImage','url('+finalBack+')');
            	$curObj.off('unveil');
            }else if(curSrc && curSrc.indexOf('NO-SWATCH-TAB.svg') >= 0) {
                $curObj.addClass('plpnoswatch-img');
            } 
        });
    });
}

function resizeMobileFilters() {
    if (util.isMobile() && $(window).width() <= 767) {
    	if(!$('body').hasClass('single-column-refinement')){
    		var $windowHeight = $(window).height();
	        var $fixedHeader = $('.fixed-header').outerHeight();
	        var $filterHeight = $('.filters').outerHeight();
	        var noScrollOffset = -5; // for change in element height after class 'no-scroll' is applied to body in animate function
            var $totalAnimate = parseInt($windowHeight) - (parseInt($fixedHeader) + parseInt($filterHeight)) + noScrollOffset;
            if($('.nanobar-sticky').length>0){
                $totalAnimate -= $('.nanobar-sticky').height();
            }
	        $('.refinements').find('.refinements-count').height($totalAnimate);
    	}
        $('.refinement.active .expended').css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
    }
}

function infiniteScroll() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');

    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1 && util.elementInViewport(loadingPlaceHolder.get(0), 250)) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function (html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('div.search-result-content').append(html);
            rating.init();
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        // For the ajax request, clear the contents of the asset-initialization array
        contentAssetHelper.clearInitFunctions();

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function (response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {
                    // nothing to catch in case of out of memory of session storage
                    // it will fall back to load via ajax
                }
                // update UI
                fillEndlessScrollChunk(response);
                productTile.init();
                contentAssetHelper.initContentAssets();
                lazyLoadTileImages();
            }
        });
    }
}

function fillEndlessScrollChunk(html, $viewMorePlaceholder) {

    // Update the rendering of the loading-placeholder
    $viewMorePlaceholder.removeClass('viewmore-loading');
    $viewMorePlaceholder.attr('data-loading-state', 'loaded').hide();
    $viewMorePlaceholder.parents('.view-more').hide();

    // Append the PLP content
    $('div.search-result-content').append(html);

    // Initialize the grid-tiles
    productTile.init();
    rating.init();
    // Re-initialize any page content assets
    contentAssetHelper.initContentAssets();

    // Re-initialize the lazy-loading of tile images
    if (window.SitePreferences.PLP_LAZY_LOAD_ENABLED) {
        lazyLoadTileImages();
    }

}

function viewMoreProducts() {

    // Initialize local variables
    var $loadingPlaceHolder,
        gridUrl,
        sessionStorageCacheKey;

    // Let's retrieve however many instances of the view-more button exist
    $loadingPlaceHolder = $('.viewmore-grid[data-loading-state="unloaded"]').last();

    // Get url hidden in DOM element
    gridUrl = $loadingPlaceHolder.attr('href');

    // Is the gridUrl valid?
    if (gridUrl !== '' && gridUrl !== undefined) {

        // Build out the session-storage cache key
        sessionStorageCacheKey = 'scroll-cache_' + gridUrl;

        // Switch state to 'loading' so the above selector only matches once
        $loadingPlaceHolder.attr('data-loading-state', 'loading');
        $loadingPlaceHolder.addClass('viewmore-loading');

        // For the ajax request, clear the contents of the asset-initialization array
        contentAssetHelper.clearInitFunctions();

        // Do we currently have the next section cached in session-storage?
        if (sessionStorage.getItem(sessionStorageCacheKey) !== null) {

            // Append the cached search-result content to the current PLP display
            fillEndlessScrollChunk(sessionStorage.getItem(sessionStorageCacheKey), $loadingPlaceHolder);

        } else {

            // Otherwise, execute an ajax request to retrieve the next section's content
            $.ajax({
                type: 'GET',
                dataType: 'html',
                url: gridUrl,
                success: function (response) {

                    // put response into cache
                    try {
                        sessionStorage[sessionStorageCacheKey] = response;
                    } catch (e) {
                        // nothing to catch in case of out of memory of session storage
                        // it will fall back to load via ajax
                    }

                    // Update the UI display
                    fillEndlessScrollChunk(response, $loadingPlaceHolder);

                }

            });

        }

    }

}

// Initialize global variables
var activecat,
    activeCatText,
    activeCategory,
    expandedPosition,
    isclearAllFlag,
    pagination,
    clickedOutSideFlag = true;

/**
 * @private
 * @function updateProductListing
 * @description replaces breadcrumbs, left-hand nav and product listing with ajax and
 * puts a loading indicator over the product listing
 */
function updateProductListing(url, sortby, selectedElement ,isKeyEnter) { 
    window.enableFilterByFlyoutCheck = false;
    var isFixedBar = $(".refinements.ws-sticky").hasClass("js-fixed-bar");    
	if(!$('body').hasClass('single-column-refinement')){
		// Prevent the ajax request from occurring if the url isn't valid
		if (!url || url === window.location.href || url.indexOf('javascript:void(0)') > -1) { return; }
	}else{
		// url === window.location.href removed to allow clear
	    if (!url || url.indexOf('javascript:void(0)') > -1) { return; }
	}
	
    // For the ajax request, clear the contents of the asset-initialization array
    contentAssetHelper.clearInitFunctions();
    
    if(selectedElement && $(selectedElement).hasClass('mobile-refinement-link') && $(window).width() < 768 && util.isMobile() && $('body').hasClass('single-column-refinement')){
    	var applyBtnUrl=url;
    	var stylesUpdated=$('.result-count.result-count-mobile.hide-desktop').html();
    	$('.refinements-count').addClass('refinement-overlay');
        url=util.appendParamToURL(url, 'responseType', 'filter');
       
    	$('.mobile-only-filter').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
            window.enableFilterByFlyoutCheck = false;
    		var refTopPos = $('.fixed-header-wrapper').height() + 10;
    		if($('.nanobar-sticky').length>0){
            	refTopPos += $('.nanobar-sticky').height();
            }
        	$('.refinements').attr('style', 'top:'+ refTopPos +'px !important');
        	$('.apply-button a').attr('href',applyBtnUrl);
        	$('[id="'+selectedElement.id+'"]').closest('.filters').siblings('.hide-desktop').hide();
    		$('.refinements-count').removeClass('refinement-overlay');
            util.updateselect();
            productTile.init();
            contentAssetHelper.initContentAssets();
            $('.refinements a').each(function () {
                if ($(this).attr('id') == activecat && $(this).attr('id') !== '' && $(this).attr('id') !== undefined) {
                    if (sortby != 'sort-by') {
                		$(this).closest('.refinement').find('.refinement-heading-category.toggle').addClass('expanded').siblings('.expended').show();
                		$('.refinement.active .expended').css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
                        $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();                      
                        resizeMobileFilters();  
                     }                  
                } 

                if (($(this).closest('.refinement').find('.expended').attr('expandedposition') == expandedPosition) && ($(window).width() <= 1023 && sortby != 'sort-by')) {
                    if (isclearAllFlag == 'device-clear-all') {
                        $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();
                    } else {
                    	if (util.isMobile() && $(window).width() <= 767) {	
                    		$(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();
                    	}else{
                    		$(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
                    	}
                    }
                }

                if (activeCatText == 'Clear' || isclearAllFlag == 'device-clear-all') {
                	if($(this).closest('.refinement').hasClass(activeCategory) && activeCatText == 'Clear' && sortby != 'sort-by' && $(window).width() < 1024) {
                        $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
                        $(this).closest('.refinement').addClass('active').siblings('.refinement').hide();
                	}
                    refinementScrollBar();
                }
            });
            $('.refinements-count .refinement').each(function () {
        		var countHeight = $(this).find('.count-values').height();
            	$(this).find('.count').removeAttr('style');
            	if(countHeight>40 && !$(this).hasClass('active')){
            		$(this).find('.count-values').addClass('hide');
            		$(this).find('.count.hide-mobile').removeClass('hide-mobile');
            		$(this).find('.count').css('display','inline-block');
            	}            	
            });
            
            $('[id="'+activecat+'"]').closest('.refinement').addClass('active');
            if($('[id="'+activecat+'"]').closest('.refinement').hasClass('refinementColor')){
            	            	
            }            
            refinementScrollBar();

            var count = Number(0);
            $('input.count-selected-value').each(function () {
                count = count + Number($(this).val());
            });
            if (count > 0 && $(window).width() <= 1023) {
                var text = '(' + count + ')';
                $('.refinements .filters a.filter span.filter-count').html(text);
                $('.refinements .refinements-count').addClass('has-selection');
                $('.refinements .filters .refinements-count .result-count').removeClass('hide');
            }
            $('.result-count.result-count-mobile.hide-desktop').html(stylesUpdated);
            colorResize();
            if(window.flyouttimer){
                clearTimeout(window.flyouttimer);
            }
            window.flyouttimer = setTimeout(function(){
                window.enableFilterByFlyoutCheck = true;
            }, 1505);
            
            });    		
	    	
    		$(window).resize();
    		
    		if(isFixedBar){
	        	$(".refinements.ws-sticky").addClass("js-fixed-bar");
	        }
            return;
    }
    else{
        if(window.flyouttimer){
            clearTimeout(window.flyouttimer);
        }
        window.flyouttimer = setTimeout(function(){
            window.enableFilterByFlyoutCheck = true;
        }, 1505); 
    }
    
    if($(window).width() < 768 && util.isMobile() && $('body').hasClass('single-column-refinement') && sortby != 'sort-by'){
    	$('.refinements-count').addClass('refinement-overlay');
    }else{
    	if($(window).width() < 768 && util.isMobile() && $('body').hasClass('single-column-refinement') && sortby == 'sort-by'){
    		progress.showLoader($('.search-result-content'));
    		if($('.loader-indicator-circle')){
    			var circle='<svg class="spinner" viewBox="0 0 50 50"><circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>';
    			$('.loader-indicator-circle').html(circle);
    		}
    	}else{
    		progress.show($('.search-result-content'));
    	}    	
    }    
    $('#main').load(util.appendParamToURL(url, 'format', 'ajax'), function () {
        window.enableFilterByFlyoutCheck = false;
    	if($(".header-main-search .header-secondary").hasClass("active")){
        	$('.refinements').addClass('search-scroll-css');
        }
    	if($(window).width() < 768 && util.isMobile() && $('body').hasClass('single-column-refinement') && sortby != 'sort-by'){
        	$('.refinements-count').removeClass('refinement-overlay');
        }else{
        	progress.hide();
        }
        history.pushState(undefined, '', url);
        
        util.updateselect();
        productTile.init();
        contentAssetHelper.initContentAssets();
        if(window.SitePreferences.PLP_LAZY_LOAD_ENABLED) lazyLoadTileImages(); 
        $('html, body').removeClass('no-scroll');
        if (clickedOutSideFlag) {
            $('.refinements a').each(function () {
                if ($(this).attr('id') == activecat && $(this).attr('id') !== '' && $(this).attr('id') !== undefined) {
                	if($('body').hasClass('single-column-refinement')){
                		if (sortby != 'sort-by') {
                        	if ($(window).width() > 1023 || $(window).width() <= 767) {
                        		$(this).closest('.refinement').find('.refinement-heading-category.toggle').addClass('expanded').siblings('.expended').show();
                        	}
                            if (util.isMobile() && $(window).width() <= 767) {
                                $('.refinement.active .expended').css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
                            }
                        }
                	}else{
                		if (sortby != 'sort-by') {
                        	if ($(window).width() > 1023 || $(window).width() <= 767) {
                        		$(this).closest('.refinement').find('.refinement-heading-category.toggle').addClass('expanded').siblings('.expended').show();
                        	}
                            if (util.isMobile() && $(window).width() <= 767) {
                                $('.refinement.active .expended').height($('.refine-by-clearall').offset().top - $('.refine-by-clearall').outerHeight() - $('.refinement-heading-category.expanded').offset().top).css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
                            }
                        }
                	}
                    

                    if ($(window).width() < 1023) {
                    	if($('body').hasClass('single-column-refinement')){
	                        if (sortby != 'sort-by') {
		                        if (util.isMobile() && $(window).width() <= 767) {	
		                            $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();
		                        }else{
		                        	$(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
		                        }
	                        }
                        }else{
                            if (sortby != 'sort-by') {
                                $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
                            }
                            $(this).closest('.refinement').addClass('active').siblings('.refinement').hide();
                        }
                        resizeMobileFilters();
                    }

                    if ($(window).width() >= 768 && $(window).width() <= 1023 && util.isMobile() && sortby != 'sort-by') {
                    	$('html, body').addClass('sort-overlay');
                    }
                }

                if (($(this).closest('.refinement').find('.expended').attr('expandedposition') == expandedPosition) && ($(window).width() <= 1023 && sortby != 'sort-by')) {
                    if (isclearAllFlag == 'device-clear-all') {
                        $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();
                    } else {
                    	if (util.isMobile() && $(window).width() <= 767 && $('body').hasClass('single-column-refinement')) {	
                    		$(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile').find('.refinements-count').show();
                    	}else{
                    		$(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
                    	}
                    }
                }

                if (activeCatText == 'Clear' || isclearAllFlag == 'device-clear-all') {
                	if($(this).closest('.refinement').hasClass(activeCategory) && activeCatText == 'Clear' && sortby != 'sort-by' && $(window).width() < 1024) {
                        $(this).closest('.refinements').addClass('js-fixed-bar').find('.filters').addClass('refinement-mobile active-css').find('.refinements-count').show();
                        $(this).closest('.refinement').addClass('active').siblings('.refinement').hide();
                	}
                    refinementScrollBar();
                }
            });
        }
        clickedOutSideFlag = true;
        if ($(window).width() > 1023) {
            // Initialize local variables
            var $primary,
                $main,
                $pagination,
                $searchResultOptions,
                $total,
                $categorySerach,
                $nanobarSticky,
                $fixedHeader;

            // Calculate the overall length of the visible page
            $primary = $('#primary').offset().top;
            $main = $('#main').offset().top;
            $fixedHeader = $('.fixed-header').outerHeight();
            // Capture the height of the individual offset-elements
            // to determine the scrollTop location (we want to scroll to the top border of
            // the 1st row of grid images and clearly show the refinements)

            // Capture the searchResults height
            if ($('.search-result-options').length > 0) {
                $searchResultOptions = $('.search-result-options').outerHeight();
            }

            // Capture the pagination height
            if ($('.pagination').length > 0) {
                $pagination = $('.pagination').outerHeight();
            }

            // Capture the refinement height
            if ($('.refinements').length > 0) {
                $categorySerach = $('.category-search').outerHeight();
            }
            
            //Capture the nanobar height if sticky
            if ($('.nanobar-sticky').length > 0) {
                $nanobarSticky = $('.nanobar-sticky').outerHeight();
            }

            // Calculate the top-pixel location by subtracting the individual height elements
            if (pagination.closest('.search-result-options').hasClass('paging')) {
                $total = $primary - ($categorySerach + $pagination + $searchResultOptions+$nanobarSticky);
            }
            if (pagination.closest('.refinement').find('.toggle').hasClass('expanded')) {
                $total = $main - $fixedHeader;
            }
            // Animate the scrolling
            $('html, body').animate({
            	scrollTop: $total
            }, 500);
        }

        if ($('.refinements').length > 0 && $(window).width() > 1023) {
            var windowMidDisplacement = -10;
            if ($('.refinement .refinement-heading-category').hasClass('expanded')) {
                if (($('.refinement .refinement-heading-category.expanded').offset().left + $('.refinement .refinement-heading-category.expanded').width() / 2) < $(window).width() / 2 + windowMidDisplacement) {
                    $('.refinement .refinement-heading-category.expanded').siblings('.expended').removeClass('left right').addClass('right');
                } else {
                    $('.refinement .refinement-heading-category.expanded').siblings('.expended').removeClass('left right').addClass('left');
                }
            }
        }
        $('<li></li>').insertAfter('.two-space-tile');
        refinementScrollBar();

        var count = Number(0);
        $('input.count-selected-value').each(function () {
            count = count + Number($(this).val());
        });
        if (count > 0 && $(window).width() <= 1023) {
            var text = '(' + count + ')';
            $('.refinements .filters a.filter span.filter-count').html(text);
            $('.refinements .refinements-count').addClass('has-selection');

            if($('body').hasClass('single-column-refinement')){
                $('.refinements .filters .refinements-count .result-count').removeClass('hide');
            }
            
        }
        else {
            $('.refinements .refinements-count').removeClass('has-selection');
        }
        $(window).resize();
        
        if(($(selectedElement).hasClass('apply-button-link') || ($(selectedElement).hasClass('device-clear-all') && $(selectedElement).hasClass('filter-open'))) && util.isMobile() && $(window).width() <= 767 && $('body').hasClass('single-column-refinement')){
        	var appliedFilters = $('.mobile-only-filter .refinements .applied-filters').attr('data-appliedfilters');
            if(appliedFilters && $(selectedElement).hasClass('apply-button-link')){
                var updatedFilters = [];
                    appliedFilters = appliedFilters.replace('[', '');
                    appliedFilters = appliedFilters.replace(']', '');
                    var formattedAppliedFilters = appliedFilters.split(',');
                    formattedAppliedFilters.forEach(function(item, index) {
                        var val = '';
                        val = formattedAppliedFilters[index].replace(' ', '');
                        updatedFilters.push(val);
                       });
                    utag_data["total_product_filtering_catgory_selection"] = updatedFilters;
            }
        	$('.filter').trigger('click');
                $('html, body').animate({
                    scrollTop: $('#primary').offset().top + 50
                }, 300);
        	$('.refinements-count .refinement').each(function () {
        		//Restore classes to original state to get the height of count values
        		$(this).find('.count-values').removeClass('hide');
        		$(this).find('.count.hide-mobile').addClass('hide-mobile');
        		
            	var countHeight = $(this).find('.count-values').height();
            	$(this).find('.count').removeAttr('style');
            	if(countHeight>40 && !$(this).hasClass('active')){
            		$(this).find('.count-values').addClass('hide');
            		$(this).find('.count.hide-mobile').removeClass('hide-mobile');
            		$(this).find('.count').css('display','inline-block');
            	}            	
            });
            colorResize();            
        }
        if(isFixedBar){
        	$(".refinements.ws-sticky").addClass("js-fixed-bar");
        }
        if(window.flyouttimer){
            clearTimeout(window.flyouttimer);
        }
        window.flyouttimer = setTimeout(function(){
            window.enableFilterByFlyoutCheck = true;
        }, 1505); 
        
        if(window.sortByOpen && $(window).width() > 767 && $(window).width() < 1024){
    		$(".sort-by").eq(0).focus().addClass('focus-outline').find('.selected-option').trigger('click');
    		$(".sort-by").eq(0).find("li.selected").addClass("focus-outline");
    	}

        if(isKeyEnter && sortby !== 'sort-by'){
        	setTimeout(function () {
            	$('[id="'+selectedElement.id+'"]:not(.refinement-color)').addClass("focus-outline").focus();
            }, 10);
        }        

        if (sortby === 'sort-by' && window.lastClickOrKey === 'key'){
            setTimeout(function () {
            $('div.sort-by:visible').find('select').focus().addClass('focus-outline');
            }, 100);
        }
        rating.init();
        if(!window.HTMLPictureElement){
            webshim.polyfill("picture");
        }
    });
}

function refinementScrollBar() {
    var $fixedHeader,
        $windowHeight,
        $filterHeight,
        $totalAnimate,
        noScrollOffset,
        $totalCount,
        $refineClearall,
        $mobileRefinement;
    var $this = $('.refinement .refinement-heading-category');
    var $thisIpad = $('.refinement .toggle-heading');
    var $expanded = $('.refinement .refinement-heading-category.expanded');
    var $expandedIpad = $('.refinement .toggle-heading.expanded');
    var $refineClear = $('.refine-by-clearall').outerHeight();
    var $refineActive = $expanded.outerHeight();
    $fixedHeader = $('.fixed-header').outerHeight();
    noScrollOffset = -5;
    $windowHeight = $(window).height();
    $filterHeight = $('.filters').outerHeight();
    $totalAnimate = parseInt($windowHeight) - (parseInt($fixedHeader) + parseInt($filterHeight)) + noScrollOffset;
    $totalCount = $totalAnimate - $refineActive - $refineClear;
    if ($($this).hasClass('expanded') && window.matchMedia("(min-width: 1024px)").matches) {
        if ($($expanded).next('.expended').find('.scroll-bar-height').height() >= 400) {
            $($expanded).next('.expended').find('.scroll-bar-height').slimScroll({
                height: '400px',
                railVisible: true,
                color: '#8f8f8f',
                railColor: '#e9e9e9',
                distance: '9px',
                alwaysVisible: true
            });
        }
    } else if (util.isMobile() && $(window).width() <= 767 && $('.refinements').length > 0) {  
    	if ($('.refinement').hasClass('active')) {
            var $refinementActive = $('.refinement.active .refinement-heading-category.toggle').offset().top;
        }
		
    	$this = $('.filter');        
        noScrollOffset = -5; // for change in element height after class 'no-scroll' is applied to body in animate function
        $windowHeight = $(window).height();
        $fixedHeader = $('.fixed-header .fixed-header-wrapper').outerHeight();

        if($('body').hasClass('single-column-refinement') && !$(this).closest('.filters').hasClass('refinement-mobile') && !$('#header').hasClass('header_fixed')){
            if ($('.filters').hasClass('refinement-mobile')) {
                $('html, body').stop().animate({
                    scrollTop: $('#primary').offset().top
                }, 500).promise().done(function(){
                    // Sticky header take time with animate to render on some devices, to overcome this Set Time Out Required
                    setTimeout(function(){
                        refinementWrapperHeightAdjustment($this, $refineClear, $refinementActive, $windowHeight, noScrollOffset);
                    }, 500);
                });
            }
        }else{
            if (!$('body').hasClass('single-column-refinement') && $('.filters').hasClass('refinement-mobile')) {
                $('html, body').stop().animate({
                    scrollTop: $('#primary').offset().top - $fixedHeader
                }, 500).promise().done(function(){
                    // Sticky header take time with animate to render on some devices, to overcome this Set Time Out Required 
                    setTimeout(function(){
                        refinementWrapperHeightAdjustment($this, $refineClear, $refinementActive, $windowHeight, noScrollOffset);
                    }, 500);
                });
            }else{
                refinementWrapperHeightAdjustment($this, $refineClear, $refinementActive, $windowHeight, noScrollOffset);
            }
        }         
    } else {
    	$('.filter').closest('.refinements').find('.refinements-count').removeAttr('style');
    	$('.filter').closest('.refinements').find('.mobile-refinement').removeAttr('style');
    }
}

function refinementWrapperHeightAdjustment($this, $refineClear, $refinementActive, $windowHeight, noScrollOffset){
    var $fixedHeader = $('.fixed-header .fixed-header-wrapper').outerHeight();
    var $filterHeight = $('.filters').outerHeight();
    var $refineClearall = $('.refine-by-clearall').is(':visible') ? ($('.refine-by-clearall').outerHeight() + 18) : 0;
    var $totalAnimate = parseInt($windowHeight) - (parseInt($fixedHeader) + parseInt($filterHeight)) + noScrollOffset;
    var $mobileRefinement = $totalAnimate - parseInt($refineClearall);
    if($('body').hasClass('single-column-refinement')){
        $mobileRefinement =$mobileRefinement - ($('.apply-button').outerHeight()+ 75);        
        if($('.refinements-count.has-selection .result-count-mobile').length>0 && !$('.refinements-count.has-selection .result-count-mobile').hasClass('hide')){
            $mobileRefinement-=$('.refinements-count.has-selection .result-count-mobile').outerHeight()
        }
        if($('.nanobar-sticky').length>0){
            $totalAnimate -= $('.nanobar-sticky').height();
            $mobileRefinement-= $('.nanobar-sticky').height();
        }        
        $this.closest('.refinements').find('.refinements-count').css({'max-height': $totalAnimate,'height': 'auto'});
        $this.closest('.refinements').find('.mobile-refinement').css({'max-height': $mobileRefinement,'height': 'auto'});
        $('.refinement.active .expended').css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch', 'left': '0' });
    }else{
        if($('.nanobar-sticky').length>0){
            $totalAnimate -= $('.nanobar-sticky').height();
            $mobileRefinement -= $('.nanobar-sticky').height();
        }
        $this.closest('.refinements').find('.refinements-count').css({ height: $totalAnimate, 'max-height': $totalAnimate});
        $this.closest('.refinements').find('.mobile-refinement').css({ height: $mobileRefinement, 'max-height': $mobileRefinement});
        $('.refinement.active .expended').height($('.refine-by-clearall').offset().top - $refineClear - $refinementActive).css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch', 'left': '0' });
    } 
}

function colorResize(){
    if($('.last-selected-filter').length>0 && $('.last-selected-filter .color-count').hasClass('hide') && ($('.last-selected-filter').height()>40 || $('.last-selected-filter .color-count').data('count') >=8 )){
        $('.last-selected-filter .color-count').removeClass('hide');
        $('.last-selected-filter .color-display').addClass('hide');
    }
}
            

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('#main');
    if($('.refinements').length !== 0) {
        var isIE =  navigator.userAgent.indexOf('MSIE') != -1;
        isIE? $('.refinements').addClass('ws-sticky').trigger('wssticky') :$('.refinements').addClass('ws-sticky');
    }
    if ($(window).width() <= 767 ){
    	$(".refinements").find(".sort-by.custom-select").parents(".hide-desktop").attr("tabindex","0");
    }
    
    // handle toggle refinement blocks
    $main.off('click', '.refinement .refinement-heading-category').on('click', '.refinement .refinement-heading-category', function (e) {
        if (window.matchMedia("(min-width: 1024px)").matches && !$(this).closest('.filters').hasClass('refinement-mobile')) {
            $(this).toggleClass('expanded').siblings('.expended').toggle();
            $(this).closest('.refinement').siblings('.refinement').find('.expended').hide();
            $(this).closest('.refinement').siblings('.refinement').find('.expanded').removeClass('expanded');
            refinementScrollBar();

            // determine which direction the refinement dropdown will be expanded based on the clicked filter element's position in window
            var windowMidDisplacement = -10;
            // we want the center refinement to open to the left when clicked by default.
            // this displacement makes it so it will only open to the right if the filter is left of center by a reasonably visible margin
            if (($(this).offset().left + $(this).width() / 2) < $(window).width() / 2 + windowMidDisplacement) {
                // left of the middle
                $(this).siblings('.expended').removeClass('left right').addClass('right');
            } else {
                // right of the middle
                $(this).siblings('.expended').removeClass('left right').addClass('left');
            }
        } else if (window.matchMedia("(min-width: 1024px)").matches && $(this).closest('.filters').hasClass('refinement-mobile')){
            $(this).toggleClass('expanded').siblings('.expended').toggle();
            $(this).closest('.refinement').siblings('.refinement').find('.expended').hide();
            $(this).closest('.refinement').siblings('.refinement').find('.expanded').removeClass('expanded');

        } else if ($(window).width() <= 767 && util.isMobile() && $('body').hasClass('single-column-refinement')) {
        	if(!$(this).closest('.refinement').hasClass('active')){
        		$(this).closest('.filters').find('.refinement').removeClass('active');
	            $(this).closest('.filters').find('.refinement-heading-category.toggle').removeClass('expanded');
	            $('.expended').hide();
	            $(this).closest('.refinement').toggleClass('active');
	            $(this).toggleClass('expanded').siblings('.expended').toggle('slide', {
	                direction: 'up'
	            }, 200, function () {
	                if (util.isMobile() && $(window).width() <= 767 && $('.refinements').length > 0) {
	                    $('.refinement.active .expended').css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
	                }
	            });
	            $('.category-refinement').hide();
	            refinementScrollBar();
        	}else{
        		$(this).closest('.filters').find('.refinement').removeClass('active');	
	            $(this).closest('.filters').find('.refinement-heading-category.toggle').removeClass('expanded');
	            $('.expended').hide();
	            $('.category-refinement').hide();
	            refinementScrollBar();
        	}
        	
        	$('.refinements-count .refinement').each(function () {
        		//Restore classes to original state to get the height of count values
        		$(this).find('.count-values').removeClass('hide');
        		$(this).find('.count.hide-mobile').addClass('hide-mobile');
        		
            	var countHeight = $(this).find('.count-values').height();
            	$(this).find('.count').removeAttr('style');
            	if(countHeight>40 && !$(this).hasClass('active')){
            		$(this).find('.count-values').addClass('hide');
            		$(this).find('.count.hide-mobile').removeClass('hide-mobile');
            		$(this).find('.count').css('display','inline-block');
            	}            	
            });        	
        	colorResize();
	            
        }else if ($(window).width() <= 767 && util.isMobile() && !$(this).closest('.filters').hasClass('active-css')) {
            $(this).toggleClass('expanded').siblings('.expended').toggle('slide', {
                direction: 'right'
            }, 200, function () {
                if (util.isMobile() && $(window).width() <= 767 && $('.refinements').length > 0) {
                    if ($('.refinement').hasClass('active')) {
                        var $refinementActive = $('.refinement-heading-category.expanded').offset().top;
                        if(!$('.backbutton').is(':visible')){
                            $('.backbutton').show();
                        }
                    }
                    $('.refinement.active .expended').height($('.refine-by-clearall').offset().top - $('.refine-by-clearall').outerHeight() - $refinementActive).css({ 'overflow-y': 'scroll', '-webkit-overflow-scrolling': 'touch' });
                }
            });
            $(this).closest('.refinement').toggleClass('active');
            $(this).closest('.filters').toggleClass('active-css');
            $('.refinement').show();
            $('.refinement.active').siblings('.refinement').hide();
            $('.category-refinement').hide();
            refinementScrollBar();
        } 
        
        if($(this).hasClass('expanded')){
 	        $(this).attr( 'aria-expanded', 'true');
         }
         else {
         	$(this).attr( 'aria-expanded', 'false');
         }
    });

    $main.off('click', '.refinement .toggle i').on('click', '.refinement .toggle i', function (e) {
        e.preventDefault();
        if ($(window).width() >= 768 && $(window).width() <= 1023) {
            $(this).closest('.toggle').find('.toggle-heading').trigger('click');
            $(this).closest('.toggle').removeClass('expanded');
            $(this).closest('.toggle').next('.expended').hide();
            $('html, body').addClass('sort-overlay');
        }
    });

    $main.off('click', '.refinement .toggle-heading').on('click', '.refinement .toggle-heading', function (e) {
        e.preventDefault();
        if ($(window).width() >= 768 && $(window).width() <= 1023) {
            $(this).toggleClass('expanded').closest('.refinement').find('expended').toggle('slide', {
                direction: 'right'
            }, 200);
            $(this).closest('.refinement').toggleClass('active');
            $(this).closest('.filters').toggleClass('active-css');
            $('.refinement').show();
            $('.refinement.active').siblings('.refinement').hide();
            $('.category-refinement').hide();
            $('html, body').addClass('sort-overlay');
            refinementScrollBar();
        }
    });

    // Outside Click Refinement Should Close
    $(document).on('click', function (e) {
    	if ($(window).width() > 1023) {
            var $currentItem = $(this).find('.expanded');
            var $currenValue = $currentItem.closest('.refinement').find('.expended');
            if ($(e.target).closest('.refinement').find('.expended').length === 0) {
                $currenValue.hide();
                $currentItem.removeClass('expanded');
                clickedOutSideFlag = false;
            }
    	} else if ($(window).width() <= 1024) {
    		var $mobileRefinement = $(this).find('.refinement-mobile');
            var $mobileRefinementValue = $mobileRefinement.closest('.filters').find('.refinements-count');
            if ($(e.target).closest('.filters').find('.refinements-count').length === 0) {            	      
                $mobileRefinementValue.hide();
                $mobileRefinement.removeClass('refinement-mobile');
                if(!$(e.target).parent().hasClass('sort-by') || !$(e.target).parent().hasClass('current_item')) {
                    $('html, body').removeClass('no-scroll');
                    if($(window).width() < 768 && $('body').hasClass('single-column-refinement')){
                    	var $mobileFilter = $('.filters');
                    	$mobileFilter.show();
                    	$mobileFilter.siblings('.hide-desktop').show();
                        $mobileFilter.siblings('.hide-desktop').find('.current_item').removeClass('current_item');
                    }
                    if(!$('#header').hasClass('header_fixed')){
                        $('.refinements').removeAttr('style');
                    }else{
                        $('.refinements').removeAttr('style');
                    }
                    $('body').removeClass('disable-scroll');
                    $('.refinements').removeClass('search-scroll-css');
                }
                clickedOutSideFlag = false;
            }
    	}   
    });

    
    $('.pt_product-search-result').prepend('<span class="dropdown-overlay"></span>');
    var amountScrolled = $(window).height() * 0.75;
    $(window).scroll(function () {
        if ($(window).scrollTop() > amountScrolled) {
            $('a.back-to-top').fadeIn('slow');
        } else {
            $('a.back-to-top').fadeOut('slow');
        }
    });

    $(document).on('click', 'a.back-to-top', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 700);
        return false;
    });

    // START - WCAG - accordion focus
    $main.off('click', '.cr-icon').on('click', '.cr-icon', function (e) {
         e.preventDefault();
         var toggleParent = $(this).closest('.cr-section');
         var toggleBtn = $(this).closest('.cr-section').find('.cr-icon:first');
         toggleBtn.toggleClass('active');        
         toggleParent.parent().toggleClass('non-active');
         if(toggleBtn.hasClass('active')){
             toggleBtn.attr('aria-expanded','true');
         } else{
             toggleBtn.attr('aria-expanded','false');
         }
    });     


    // WCAG - accordion focus
    $main.off('keypress', '.refinement-accordion').on('keypress', '.refinement-accordion', function (e) {
        if(e.which === 13){
            $(this).closest('.cr-section').find('.cr-icon').trigger('click');
        }        
    });

    $('html.no-scroll, body.no-scroll').on('touchmove touchstart', function (e) {
        if (e.target == this) { e.preventDefault(); }
    });

    // Update the pdpLink for the grid-tile whenever a tile-link is clicked; this ensures
    // that the swatch-url parameters are copied to the name-link and will be used to
    // launch the PDP (this also copies all hashed parameters to the name-link)
    $main.on('click', '.product-tile a:not("#quickviewbutton")', function () {
        productTile.updatePDPLinkParameters(this);
    });

    // Similarly, let's check on every mouse-over on a tile to see if the PDP url has
    // been initialized; if it hasn't, let's do it pro-actively so that the PDP url has
    // the hash values appended to it
    $main.on('mouseover', '.product-tile', function () {
        // Initialize local variables
        var $tile = $(this);
        var $nameLink;

        // Check the tile to see if it's been initialized
        if ($tile.data('pdpurl-initialized') !== true) {
            // If not, force the initialization
            $nameLink = $tile.find('.name-link');
            productTile.updatePDPLinkParameters($nameLink);

            // Tag the tile that the initialization is complete
            $tile.data('pdpurl-initialized', true);
        }
    });

        // handle events for updating grid
    $main.off('click keypress', '.refinements a,  .refinement-mobile').on('click keypress', '.refinements a, .refinement-mobile', function (e) {
            e.preventDefault();
            window.enableFilterByFlyoutCheck = false; 
            if (!$(this).hasClass('no-ajaxcall') && !$(this).find('.no-ajaxcall').length) {

            }
            else{
                if(window.flyouttimer){
                    clearTimeout(window.flyouttimer);
                }
                window.flyouttimer = setTimeout(function(){
                    window.enableFilterByFlyoutCheck = true;
                }, 1505);
            }
        });

    // handle events for updating grid
    $main.off('keydown mouseup keypress', '.refinements a, .breadcrumb-refinement-value a, .clear-refinement a, .refine-by-clearall a').on('keydown mouseup keypress', '.refinements a, .breadcrumb-refinement-value a, .clear-refinement a, .refine-by-clearall a', function (e) {
        window.enableFilterByFlyoutCheck = false; 
        var isKeyEnter = false;
        if(e.type === "keydown" || e.type === "keypress"){
        	if($(this).hasClass('filterOption') || $(this).hasClass('filter')){  
        		if (e.which !== 32) return;
        	}
        	else{
        		if (e.which !== 13) return;
        	}
            isKeyEnter = true;
        }
        e.preventDefault();
        if (!$(this).hasClass('no-ajaxcall')) {
            // don't intercept for category and folder refinements, as well as unselectable
            if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
                return;
            }

            // don't intercept pagination requests when the loader is displayed
            if (progress.isLoading() === true) {
                return false;
            }
            
            // Close the filter menu single column refinement when apply is empty
            if(this.href.indexOf('javascript:void(0)') > -1 && $(this).hasClass('apply-button-link') && util.isMobile() && $(window).width() <= 767 && $('body').hasClass('single-column-refinement')){
                $('.filter').trigger('click keypress');
            }
            
            if ($(this).hasClass('clear')) {
            	activeCategory = $(this).closest('.refinement').attr('class').split(' ')[1];
            }

            activecat = $(this).attr('id');
            activeCatText = $(this).text();
            expandedPosition = $(this).closest('.refinement').find('.expended').attr('expandedposition');
            isclearAllFlag = $(this).attr('isclearall');
            clickedOutSideFlag = true;
            pagination = $(this);
            var that=this;
            updateProductListing(this.href,null,that,isKeyEnter);
        }
    });
    
    $main.off('click keypress', '.filter').on('click keypress', '.filter', function (e) {
        if ($(e.target).closest('.filters').hasClass('filters')) {
            $(this).closest('.filters').toggleClass('refinement-mobile');
            $('html, body').removeClass('no-scroll sort-overlay');
            
        }
        if ($(this).closest('.filters').hasClass('refinement-mobile') && $(window).width() < 768) {
            $(this).attr('aria-expanded','true');          
            $('body').addClass('disable-scroll');
            $('.refinements').addClass("js-fixed-bar");
            if($(".header-main-search .header-secondary").hasClass("active")){
            	$('.refinements').addClass('search-scroll-css');
            }
            if($('body').hasClass('single-column-refinement')){
	            var refTopPos = $('.fixed-header-wrapper').height() + 10;
	            if($('.nanobar-sticky').length>0){
	            	refTopPos += $('.nanobar-sticky').height();
	            }
	            $('.refinements').attr('style', 'top:'+ refTopPos +'px !important');
	            $(this).closest('.filters').siblings('.hide-desktop').hide();
	            $('.refinements-count .refinement').each(function () {
	        		//Restore classes to original state to get the height of count values
	        		$(this).find('.count-values').removeClass('hide');
	        		$(this).find('.count.hide-mobile').addClass('hide-mobile');
	        		
	            	var countHeight = $(this).find('.count-values').height();
	            	$(this).find('.count').removeAttr('style');
	            	if(countHeight>40 && !$(this).hasClass('active')){
	            		$(this).find('.count-values').addClass('hide');
	            		$(this).find('.count.hide-mobile').removeClass('hide-mobile');
	            		$(this).find('.count').css('display','inline-block');
	            	}            	
                });
                colorResize();
            }
        } else {
        	$(this).attr('aria-expanded','false');
        	if($(window).width() < 768 && $('body').hasClass('single-column-refinement')){
        		$(this).closest('.filters').siblings('.hide-desktop').show();
            	$('.refinements').removeAttr('style');
        	}        	
            $('body').removeClass('disable-scroll');
            $('.refinements').removeClass('search-scroll-css');
        }
        if(!$('.filters.refinement-mobile').hasClass('active-css') && $('.refinements-count').hasClass('has-selection') && $(window).width() < 768 && !$('.mobile-refinement .refinement').hasClass('active')){
            $('.backbutton').hide();
        }
        refinementScrollBar();
    });
    
    $main.off('click', '.view-results').on('click', '.view-results', function () {
        $(this).closest('.filters').toggleClass('refinement-mobile');
        $('html, body').removeClass('no-scroll');
        $('body').removeClass('disable-scroll');
        $('.refinements').removeClass('search-scroll-css');
        if($('body').hasClass('single-column-refinement')){
        	$(this).closest('.filters').siblings('.hide-desktop').show();
        	$('.refinements.ws-sticky.js-fixed-bar').removeAttr('style');
        	if(!$('#header').hasClass('header_fixed')){
        		$('.refinements.ws-sticky').removeClass('js-fixed-bar');
        	}
        }
    });

    $main.off('click keypress', '.backbutton').on('click keypress', '.backbutton', function (e) {
    	 e.preventDefault();
    	 $(this).closest('.refinements-count').find('.refinement.active').find('.refinement-heading-category').attr( 'aria-expanded', 'false').addClass('focus-outline').focus();
        $(this).closest('.filters').toggleClass('active-css');
        $(this).closest('.filters').find('.refinement').removeClass('active');
        $(this).closest('.filters').find('.refinement-heading-category.toggle').removeClass('expanded');
        $('.refinement').show();
        $('.expended').hide();
        $('.category-refinement').hide();
        if(!$('.filters.refinement-mobile').hasClass('active-css') && $('.refinements-count').hasClass('has-selection') && $(window).width() < 768 && !$('.mobile-refinement .refinement').hasClass('active')){
           $('.backbutton').hide();
        }
        refinementScrollBar();
    });
    
    // handle sorting change
    $main.on('change', '.sort-by select', function (e) {
        e.preventDefault();
        pagination = $(this);
        updateProductListing($(this).find('option:selected').val(), 'sort-by',$(this).find('option:selected'));
        $('body').removeClass('disable-scroll');
        productTile.init();
    }).on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            pagination = $(this);
            updateProductListing(refineUrl);
            productTile.init();
        }
    }).on('click', '.viewmore-grid', function (e) {
        e.preventDefault();
        viewMoreProducts();
        productTile.init();
    });

    var count = Number(0);
    $('input.count-selected-value').each(function () {
        count = count + Number($(this).val());
    });

    if (count > 0 && $(window).width() <= 1023) {
        var text = '(' + count + ')';
        $('.refinements .filters a.filter span.filter-count').html(text);
        $('.refinements .refinements-count').addClass('has-selection');
    }
    else {
        $('.refinements .refinements-count').removeClass('has-selection');
    }

    // navigation hover delay if cursor coming from filters
    if ($(window).width() > 1023) {
        $main.on('mouseenter', '.refinements', function () {
            $('#navigation .menu-category li').css('pointer-events', 'none');
            $('#navigation .menu-category').addClass('safe-click-area');
        });
        $main.on('mouseleave', '.refinements', function () {
            setTimeout(function () {
                $('#navigation .menu-category li').css('pointer-events', 'inherit');
            }, 200);
        });
        $('#navigation .menu-category li').on('mouseenter', function(){
            $(this).closest('.menu-category').removeClass('safe-click-area');
        });
    }

    var lastScrollTop = 0;
    $(window).scroll(function () {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            scrollDirection = 'down';
        } else {
            scrollDirection = 'up';
        }
        lastScrollTop = st;
    });
}

/**
 * @function loadProductsBackPlp
 * @description Loads products back to the PLP
 * @param {Boolean} initialInit Describes if this call of loadProducts is an initial init for the page
 */
function loadProductsBackPlp(initialInit) {

    // Default the initial-init flag (prevents duplicate initialization of gridTiles)
    if (initialInit === undefined) { initialInit = false; }

    // Helper function that abstracts the removal / clearing on PLP cookies
    var clearPLPCookies = function clearPLPCookies () {
        util.removeCookie('viewLink');
        util.removeCookie('productId');
        //util.removeCookie('pidcgid');
        util.removeCookie('categoryId');
    };

    // Only evaluate this if we have a cached view-link and referenced productId
    if (util.getCookie('viewLink') !== '' && util.getCookie('viewLink') !== undefined &&
        util.getCookie('productId') !== '' && util.getCookie('productId') !== undefined &&
        $('.currentcategory').val() === util.getCookie('categoryId')) {

        // Check if the product that was selected is visible in the product-listing
        // If it is, then scroll down to it and bring it into the mobile window
        var checkAvailableId = function (id) {

            // Exit early if we don't have a valid product
            if (id === '' || id === undefined) { return; }

            // Create a reference to the product-tile referenced
            var $selectedProductTile = $('.product-tile[data-itemid="' + id + '"]');

            // Was a valid tile found?
            if ($selectedProductTile.length > 0) {

                // Don't re-initialize the tile on the initial it
                if (initialInit === false) { productTile.init(); }

                // Scroll down to the identified product tile
                setTimeout(function () {
                    util.scrollBrowser($selectedProductTile.offset().top + 150);
                }, 100);

                // Clear / reset the PLP cookies
                clearPLPCookies();

            } else {

                loadMoreItems();

            }

        };

        // This function is used to load additional products into the mobile PLP
        var loadMoreItems = function () {

            // Let's retrieve however many instances of the view-more button exist
            var $loadingPlaceHolder = $('.viewmore-grid[data-loading-state="unloaded"]');

            // Get the current / last view-more grid url
            var gridUrl = $('.viewmore-grid').last().attr('href');
            var scrollCacheKey = 'scroll-cache_' + gridUrl;
            var cookieProductId = util.getCookie('productId');

            // Was a valid grid-url found?
            if (gridUrl !== undefined) {

                // If so, then check session storage to determine if we can update
                // the display mark-up with the cached PLP content
                if (sessionStorage.getItem(scrollCacheKey) !== null) {

                    // Switch state to 'loading' so the above selector only matches once
                    $loadingPlaceHolder.attr('data-loading-state', 'loading');
                    $loadingPlaceHolder.addClass('viewmore-loading');

                    // Append the cached search-result content to the current PLP display
                    fillEndlessScrollChunk(sessionStorage.getItem(scrollCacheKey), $loadingPlaceHolder);

                    // Was a productID set?  If so, then evaluate if it can be selected
                    checkAvailableId(cookieProductId);

                }

            }

        };

        loadMoreItems();

    } else {

        // Clear / reset the PLP cookies
        clearPLPCookies();

    }

}

module.exports.refinementScrollBar = refinementScrollBar;
exports.init = function () {
    
    // Initialize the PLP libraries
    productTile.init();
    initializeEvents();

    // Re-load any cached products back in the PLP for mobile
    loadProductsBackPlp(true);

    // Enable lazy loading -- if it's configured and enabled
    if (window.SitePreferences.PLP_LAZY_LOAD_ENABLED) { lazyLoadTileImages(); }

    // Enable infinite scroll -- if it's configured and enabled
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $(window).on('scroll', infiniteScroll);
    }

    //------------------------------------------------
    // This function listens for back / forward click
    // events, and look-up in the history for the last
    // url; if the url exists, we re-direct
    //------------------------------------------------

    $(window).on('popstate', function (e) {

        // Initialize local variables
        var lastUrl;

        // Exit early if no history exists
        if (e.originalEvent.path.length === 0) { return; }

        // Get the path to the lastUrl
        lastUrl = e.originalEvent.path[0].location.href;

        // Re-direct the user to the last url
        if (lastUrl.toString() !== '') {
            window.location.href = lastUrl;
        }

    });

    // SC-9149
    $(".category-seo-text .read-more").on("click", function(e){
        e.preventDefault();
        $(this).closest(".category-seo-text").addClass("expand");
    });
    $(".category-seo-text .read-less").on("click", function(e){
        e.preventDefault();
        $(this).closest(".category-seo-text").removeClass("expand");
        $(this).closest(".category-seo-text")[0].scrollIntoView();
        $("body, html").scrollTop($("body, html").scrollTop() - 120);
        $(this).closest(".category-seo-text").find(".content-inline").css("display","block");
        setTimeout(function(thisRef){
            $(thisRef).closest(".category-seo-text").find(".content-inline").removeAttr("style");
        }, 100, this);
    });

};
